import React from 'react'

interface ISliceEditorWrapperProps {
  className?: string
  onBlur: () => void
  onKeyDown?: React.KeyboardEventHandler
  children?: React.ReactNode
}

const SliceEditorWrapper = ({
  children,
  className,
  onBlur,
  onKeyDown,
}: ISliceEditorWrapperProps) => {
  const rootRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    rootRef.current?.focus()
  }, [])

  const handleKeyDown: React.KeyboardEventHandler<HTMLDivElement> = (event) => {
    if (event.target === event.currentTarget) {
      if (event.key.startsWith('Arrow')) {
        return onBlur()
      } else {
        onKeyDown && onKeyDown(event)
      }
    }
  }

  return (
    <div ref={rootRef} tabIndex={0} onKeyDown={handleKeyDown} className={className}>
      {children}
    </div>
  )
}

export default SliceEditorWrapper
